<ng-sidebar-container class="container">
  <ng-sidebar [animate]="animated"
    [ngClass]="{'docked-side': !sidebar, 'animate-checked': animate, 'animate-unchecked': animate}"
    [(opened)]="sidebar" [dock]="dock" dockedSize="60px">
    <app-sidenav></app-sidenav>
  </ng-sidebar>
</ng-sidebar-container>
<app-header></app-header>
<div class="page" [ngClass]="{'checked': sidebar}" id="page" #page>
  <section class="container-fluid">
    <router-outlet></router-outlet>
  </section>
</div>
<app-footer></app-footer>

<button
  type="button"
  class="whatsapp-fab"
  (click)="openWhatsappSupport()"
  pTooltip="Falar com Suporte"
  tooltipPosition="left"
  aria-label="Abrir conversa no WhatsApp com o suporte">
  <fa-icon [icon]="['fab', 'whatsapp']"></fa-icon>
</button>

<p-dialog [(visible)]="showTermsDialog" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [dismissableMask]="false" [style]="{width: '580px', maxWidth: '92vw'}">
  <ng-template pTemplate="header">
    <span style="display:flex; align-items:center; gap:10px; font-weight:700; font-size:15px;">
      <i class="pi pi-shield"></i> Termos de Uso da Plataforma
    </span>
  </ng-template>

  <div style="padding:20px 26px 14px;">
    <span style="display:inline-flex; align-items:center; gap:7px; background:#ddeefb; color:#1a5f96;
                 font-size:12.5px; font-weight:700; padding:5px 12px; border-radius:6px; margin-bottom:16px;">
      ACEITE OBRIGATÓRIO · PRIMEIRO ACESSO
    </span>

    <p style="font-size:14px; line-height:1.6; margin-bottom:20px; color:#444b52;">
      Para continuar usando o EasyWeb, a marina precisa aceitar os Termos de Uso da Plataforma
      EasyMarine. O documento define a relação de uso da plataforma, incluindo responsabilidades,
      proteção de dados (LGPD) e ações comerciais.
    </p>

    <label style="display:flex; align-items:flex-start; gap:12px; background:#eaf4fc; border:1px solid #c9e1f5;
                  border-radius:6px; padding:13px 15px; margin-bottom:10px; cursor:pointer;">
      <p-checkbox [(ngModel)]="termsChecked" [binary]="true" inputId="acceptTerms"></p-checkbox>
      <span style="font-size:13.5px; line-height:1.5; color:#444b52;">Li e aceito os
        <strong>Termos de Uso da Plataforma</strong> EasyMarine.</span>
    </label>

    <!-- Termo cadastrado como texto (rich text): baixa o PDF gerado no navegador (sem preview inline). -->
    <button *ngIf="termsContent" type="button" (click)="baixarTermoPdf()"
      style="display:inline-flex; align-items:center; gap:8px; background:none; border:none; cursor:pointer;
             color:#2f7fd1; font-size:13.5px; font-weight:600; padding:8px 0; margin:4px 0 6px;">
      <i class="pi pi-download"></i> Baixar termo em PDF
    </button>

    <!-- Termo cadastrado como PDF anexado: link direto ao documento. -->
    <a *ngIf="!termsContent && termsDocUrl" [href]="termsDocUrl" target="_blank" rel="noopener"
      style="display:inline-flex; align-items:center; gap:8px; color:#2f7fd1; font-size:13.5px; font-weight:600;
             text-decoration:none; padding:8px 0; margin:4px 0 6px;">
      <i class="pi pi-download"></i> Ver documento completo (PDF)
    </a>

    <p style="font-size:12px; color:#8b9198; margin:0;">
      Termos de Uso da Plataforma · Versão {{ termsVersion }}
    </p>
  </div>

  <ng-template pTemplate="footer">
    <div style="display:flex; justify-content:space-between; align-items:center; gap:16px; padding:14px 26px 20px;">
      <button *ngIf="termsRequireAcceptance" type="button" (click)="recusarTermos()"
        style="background:#e5484d; color:#fff; border:none; border-radius:6px; padding:10px 26px;
               font-size:13px; font-weight:700; letter-spacing:.05em; text-transform:uppercase; cursor:pointer;">
        Recusar
      </button>
      <button *ngIf="!termsRequireAcceptance" type="button" (click)="cancelarTermos()"
        style="background:#fff; color:#5a6470; border:1px solid #cfd6dd; border-radius:6px; padding:10px 26px;
               font-size:13px; font-weight:700; letter-spacing:.05em; text-transform:uppercase; cursor:pointer;">
        Cancelar
      </button>

      <span *ngIf="!termsChecked" style="display:flex; align-items:center; gap:6px; font-size:12px; color:#8b9198;">
        <i class="pi pi-lock"></i> Marque o item para habilitar o aceite
      </span>

      <button type="button" [disabled]="!termsChecked || acceptingTerms" (click)="acceptMarinaTerms()"
        [style.background]="termsChecked ? '#2f7fd1' : '#d8dadd'"
        [style.color]="termsChecked ? '#fff' : '#9aa0a6'"
        [style.cursor]="termsChecked ? 'pointer' : 'not-allowed'"
        style="border:none; border-radius:6px; padding:10px 26px; font-size:13px; font-weight:700;
               letter-spacing:.05em; text-transform:uppercase;">
        {{ acceptingTerms ? 'Registrando...' : 'Aceitar' }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
